import successDialog from "../../components/miniDialog.vue";
export default {
  data() {
    return {
      showDialog: false,
      wordArr: [],
      size: 36,
      nowIndex: 0,
      maxIndex: 0,
      answerReport: "",
      goBackNum: 0,
      goBackMaxNum: 100,
      wrongNum: 0,
    };
  },
  components: {
    successDialog,
  },
  methods: {
    clickConfirm() {
      this.nowIndex = 0;
      // let next = this.$route.params.step * 1 + 1;
      // this.$router.push({ path: `${next}` });
      this.showDialog = false;
    },
    clickClose() {
      console.log("关闭暂缓");
      this.showDialog = false;
    },
  },
};
